import { useEffect, useMemo, PropsWithChildren } from 'react';
import { SessionContext } from '../contexts';
import { useAuthStore } from '../services/store';

/**
 * Simplified Session provider for B2B mode (no blockchain/wallet support)
 */
const SessionB2B = ({ children }: PropsWithChildren) => {
  const { isAuthenticated, checkAuthStatus } = useAuthStore();

  // Check auth status on mount only
  useEffect(() => {
    checkAuthStatus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run on mount - checkAuthStatus is stable from Zustand

  const contextValue = useMemo(
    () => ({
      isAuthenticated,
      signingInWithWallet: false,
      signInWithWallet: async () => {
        // No-op in B2B mode - wallet login not supported
      },
    }),
    [isAuthenticated]
  );

  return <SessionContext value={contextValue}>{children}</SessionContext>;
};

export { SessionB2B };


